import { Stack } from '@mui/material';
import styled from 'styled-components';

export const OverlayContainer = styled(Stack)`
  && {
    z-index: 10;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
  }
`;
